import React, { useEffect, useState } from "react";
import { Span } from "../../../../../Span";
import { Link } from "../../../../../Link";
import { Box } from "../../../../../Box";
import { Flex } from "../../../../../Flex";
import { Field } from "formik";
import { FormikSquareCheckbox } from "../../../../../FormikSquareCheckbox";

interface Props {
  id: string;
  onSelectTermsConditions: (checked: boolean) => void;
}

export const ReviewFormDeclarations: React.FC<Props> = ({
  id,
  onSelectTermsConditions,
}) => {
  const [authorityChecked, setAuthorityChecked] = useState(false);
  const [vectorEquipmentChecked, setVectorEquipmentChecked] = useState(false);
  const [newConnCostsChecked, setNewConnCostsChecked] = useState(false);
  const [privacyPolicyChecked, setPrivacyPolicyChecked] = useState(false);

  useEffect(() => {
    const allChecked =
      authorityChecked &&
      vectorEquipmentChecked &&
      newConnCostsChecked &&
      privacyPolicyChecked;
    onSelectTermsConditions(allChecked);
  }, [
    onSelectTermsConditions,
    authorityChecked,
    vectorEquipmentChecked,
    newConnCostsChecked,
    privacyPolicyChecked,
  ]);

  return (
    <Box id={id}>
      <Span
        fontSize={4}
        lineHeight={4}
        fontWeight="medium"
        mb={5}
        mr={3}
        alignSelf="flex-start"
      >
        Declarations
      </Span>

      <Flex flexDirection="column" mt={5}>
        <Flex mb={5}>
          <Field
            id="have-authority"
            name="declarations[0]"
            label={() => (
              <Span>
                {
                  "I have the authority from the property owner to permanently disconnect (decommission) this ICP."
                }
              </Span>
            )}
            onCheckedChange={(checked: boolean) => setAuthorityChecked(checked)}
            mr={2}
            checked={authorityChecked}
            value={
              "I have the authority from the property owner to permanently disconnect (decommission) this ICP."
            }
            component={FormikSquareCheckbox}
          />
        </Flex>

        <Flex mb={5}>
          <Field
            id="change-to-vector-equipment"
            name="declarations[1]"
            label={() => (
              <Span>
                {
                  "I understand this permanent disconnection (decommission) will generally not remove fixed Vector owned assets, such as pits, pillars or poles. If I would like any fixed Vector owned assets removed, I need to request a "
                }{" "}
                <Link href="https://www.vector.co.nz/personal/electricity/connection-change/vector-equipment">
                  change to Vector equipment.
                </Link>
              </Span>
            )}
            onCheckedChange={(checked: boolean) =>
              setVectorEquipmentChecked(checked)
            }
            checked={vectorEquipmentChecked}
            value={
              "I understand this permanent disconnection (decommission) will generally not remove fixed Vector owned assets, such as pits, pillars or poles. If I would like any fixed Vector owned assets removed, I need to request a change to Vector equipment."
            }
            mr={2}
            component={FormikSquareCheckbox}
          />
        </Flex>

        <Flex mb={5}>
          <Field
            id="new-connection-costs"
            name="declarations[2]"
            label={() => (
              <Span>
                {
                  "I understand if I want to make a connection in the future, I will be required to request a new connection, and this new connection may be subject to a capital contribution payment or other additional costs."
                }
              </Span>
            )}
            onCheckedChange={(checked: boolean) =>
              setNewConnCostsChecked(checked)
            }
            checked={newConnCostsChecked}
            value={
              "I understand if I want to make a connection in the future, I will be required to request a new connection, and this new connection may be subject to a capital contribution payment or other additional costs."
            }
            mr={2}
            component={FormikSquareCheckbox}
          />
        </Flex>

        <Flex mb={5}>
          <Field
            id="privacy-policy"
            name="declarations[3]"
            label={() => (
              <Span>
                {"I have read and understand Vector’s"}{" "}
                <Link href="https://www.vector.co.nz/privacy-policy">
                  privacy policy
                </Link>{" "}
                {
                  "as it relates to personal information that we collect from you as part of this process."
                }
              </Span>
            )}
            onCheckedChange={(checked: boolean) =>
              setPrivacyPolicyChecked(checked)
            }
            checked={privacyPolicyChecked}
            value={
              "I have read and understand Vector’s privacy policy as it relates to personal information that we collect from you as part of this process."
            }
            mr={2}
            component={FormikSquareCheckbox}
          />
        </Flex>
      </Flex>
    </Box>
  );
};
